const en = {
  // Navigation
  nav: {
    family: 'InventoTrack Family',
    person: 'person',
    persons: 'persons',
    scanner: 'Scanner',
    receipt: 'Receipt',
    account: 'Account',
    logout: 'Logout',
    alerts: 'alert',
    alertsPlural: 'alerts',
  },
  // Stats cards
  stats: {
    householdItems: 'Household Items',
    toBuy: 'To Buy',
    householdSize: 'Household Size',
    clickToEdit: 'Click to edit',
    dailyReport: 'Daily Report',
    send: 'Send',
  },
  // Tabs
  tabs: {
    stock: 'Household Stock',
    shopping: 'Items to Buy',
    budget: 'Budget',
    articles: 'My Items',
    history: 'History',
    suggestions: 'Suggestions',
    ai: 'AI Assistant',
    learning: 'Learning',
    support: 'Feedback & Support',
    about: 'About',
  },
  // Stock tab
  stock: {
    title: 'Household Stock',
    addArticle: 'Add Item',
    remaining: 'Left',
    days: 'days',
    daysShort: 'd',
    alert: 'Restock needed!',
    noItems: 'No items in stock',
    noItemsDesc: 'Add your first items to start tracking your household stock.',
    buy: 'Buy',
    consume: 'Consume',
    stockLabel: 'Stock',
    threshold: 'Threshold',
    perPersonDay: 'per person/day',
    totalHouseholdDay: 'total household/day',
  },
  // Articles tab
  articles: {
    title: 'My items',
    addNew: 'New item',
    category: 'Category',
    unit: 'Unit',
    perishable: 'Perishable',
    edit: 'Edit',
    delete: 'Delete',
    noArticles: 'No items',
    noArticlesDesc: 'Start by adding your daily items.',
    confirmDelete: 'Confirm deletion',
    confirmDeleteMsg: 'Are you sure you want to delete',
    deleteWarning: 'along with all associated movements?',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  // Forms
  form: {
    name: 'Name',
    category: 'Category',
    unit: 'Unit',
    alertThreshold: 'Consumption alert threshold (alarm when this level is reached)',
    perishable: 'Perishable',
    expiryDate: 'Expiry date',
    quantity: 'Quantity',
    source: 'Source',
    note: 'Note',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    close: 'Close',
  },
  // Movement types
  movement: {
    purchase: 'Purchase',
    sale: 'Sale',
    consumption: 'Consumption',
    addMovement: 'Add movement',
    article: 'Item',
    type: 'Movement type',
    quickPurchase: 'Quick purchase',
    enterQuantity: 'Enter quantity',
    validatePurchase: 'Validate purchase',
  },
  // Suggestions
  suggestions: {
    title: 'Suggested Items',
    description: 'Common household items',
    addQuick: 'Add',
  },
  shoppingPlanner: {
    badge: 'Smart suggestions',
    title: 'Items to Buy',
    description: 'See your most useful recommendations in a clear mobile-first view, prioritized by recent purchases and frequent habits.',
    customArticle: 'Add a custom item',
    toBuySection: '🛒 Items to Buy',
    toBuyDescription: 'Smart suggestions to restock or plan for later.',
    stockSection: '🏠 Household Stock',
    stockDescription: 'Items already purchased, with quick restock access.',
    emptySuggestions: 'Everything looks under control right now. Add a custom item or wait for the next recommendation.',
    emptyStock: 'Your household stock will appear here after your first purchases.',
    recent: 'Recent',
    frequent: 'Frequent',
    threshold: 'Threshold',
    purchaseCount: 'Purchased {count} times recently',
    catalogHint: 'Suggestion from the smart catalog',
    moreIdeas: 'More useful ideas',
    buyAgain: 'Buy again',
  },
  budget: {
    title: 'Monthly budget',
    description: 'Track this month’s spending, adjust each limit directly on its card, and receive useful alerts.',
    loading: 'Loading monthly budget...',
    period: 'Tracked period',
    global: 'Overall budget',
    remaining: 'Estimated remaining',
    cardBudget: 'Target budget',
    adjustOnCard: 'Direct slider on this card',
    preciseEdit: 'Exact amount',
    useSuggestion: 'Use suggestion',
    saveThisBudget: 'Save',
    saving: 'Saving...',
    tapToEdit: 'Tap to edit',
    masterRuleTitle: 'Master/sub-budget rule',
    masterRuleHint: 'The sum of category budgets must stay less than or equal to the overall budget.',
    allocationSummary: 'Categories total: {total} € / Overall budget: {global} €',
    maxAllowedForCategory: 'Maximum allowed for this category: {amount} €',
    globalMinByCategories: 'If you lower overall budget, category budgets are auto-adjusted to stay within {amount} €.',
    suggestedGlobal: 'Suggested amount: {amount} € based on your recent history.',
    suggestedCategory: 'Suggested budget: {amount} €',
    noAlerts: 'No alert right now. Your budget is under control.',
    smartAlertsTitle: 'Smart alerts',
    smartAlertsDescription: 'Based on the current month without cluttering purchase history.',
    badges: {
      customized: 'Custom budget',
      suggested: 'Suggested budget',
    },
    categories: {
      courses: 'Groceries',
      vetements: 'Clothing',
      restaurant: 'Restaurants',
      loisirs: 'Leisure',
    },
    alertLabels: {
      global: 'overall budget',
      courses: 'groceries budget',
      vetements: 'clothing budget',
      restaurant: 'restaurant budget',
      loisirs: 'leisure budget',
    },
    alertLevels: {
      info: 'Info',
      warning: 'Warning',
      exceeded: 'Exceeded',
    },
    alertMessages: {
      info: 'You have reached 80% of the {label}.',
      warning: 'The {label} is almost reached.',
      exceeded: 'The {label} has been exceeded.',
    },
    labels: {
      spent: '{amount} € spent',
    },
    success: {
      saved: 'Monthly budget updated',
    },
    errors: {
      load: 'Unable to load monthly budget',
      save: 'Error while saving budget',
      categorySumExceedsGlobal: 'Category total exceeds overall budget by {extra} €.',
      categoryClampedToGlobal: 'Category budget was automatically adjusted to {amount} € to respect the overall budget.',
    },
  },
  newItem: {
    modalTitle: 'New item',
    modalDescription: 'Add a new household item with a complete popup even on mobile.',
    suggestionButton: 'Suggestions',
    menuTitle: '✨ Smart suggestions',
    menuDescription: 'Recently purchased items appear first, then the rest of the recommended list below.',
    suggestionLabel: 'Suggested items',
    suggestionHelp: 'Use the dropdown to quickly find recent items and useful suggestions.',
    dropdownTitle: 'Choose a suggested item',
    dropdownSubtitle: 'Phone-friendly dropdown menu',
    searchPlaceholder: 'Search an item, category, or unit...',
    noSuggestionResult: 'No suggestion found',
    recentSuggestions: 'Recent suggestions',
    allSuggestions: 'All suggestions',
    recentBadge: 'Recent',
    alreadyInStock: 'Already in your stock',
    tapToFill: 'Tap to prefill',
    nameLabel: 'Item name',
    namePlaceholder: 'Eg: Bananas, Milk, Rice...',
    inputHelp: 'The dropdown groups recent purchases and the rest of the recommended catalog.',
    initialQuantity: 'Initial quantity (optional)',
    initialPrice: 'Initial price (required for purchase)',
    knownTitle: '✅ Item recognized!',
    unknownTitle: '⚠️ Unknown item',
    unknownDescription: 'Please estimate your daily consumption per person.',
    dailyQuantity: 'Quantity per day',
  },
  notifications: {
    title: 'Notifications ({count})',
    empty: 'No notifications',
    markRead: 'Mark as read',
    markAll: 'Mark all as read',
    markAllSuccess: 'All notifications marked as read',
    budgetTitle: 'Budget alert {month}',
    now: 'Just now',
    minutesAgo: '{count} min ago',
    hoursAgo: '{count} h ago',
    daysAgo: '{count} d ago',
  },
  // AI Assistant
  ai: {
    title: 'AI Assistant - Estimation',
    description: 'AI analyzes your consumption and estimates stock duration',
    estimate: 'Estimate',
    dailyConsumption: 'Daily consumption',
    confidence: 'Confidence',
    source: 'Source',
    noEstimation: 'Click "Estimate" to get an AI analysis',
    smartTitle: 'Smart consumption estimation',
    smartDesc: 'Our AI analyzes your consumption habits and estimates your household needs.',
    smartHint: 'Click the AI (brain) button next to each item to get a personalized estimate based on your history and household size.',
    recentEstimations: 'Recent estimations',
    householdOf: 'Household of',
    referenceFallback: 'Estimation based on reference data',
  },
  // Learning
  learning: {
    title: 'Automatic Learning',
    description: 'The system learns from your consumption habits to improve estimates',
    learned: 'Learned',
    base: 'Base',
    efficiency: 'Efficiency',
    records: 'records',
    noPatterns: 'No learning data yet',
    noPatternsDesc: 'Consumption patterns will improve with usage.',
    householdSize: 'Household size',
    smartTitle: 'Intelligent learning system',
    smartDesc: 'InventoTrack automatically learns from your consumption habits. Each time you click the consumption (-) button, AI improves and adapts alerts to your household.',
    referencesTitle: 'Reference data used',
    learnedPatterns: 'Learned patterns',
    learnedConsumption: 'Learned consumption',
    baseConsumption: 'Reference consumption',
    basedOn: 'Based on',
    record: 'record',
    recordsPlural: 'records',
    learningLabel: 'Learning',
    noLearningYet: 'No learning yet',
    noLearningStart: 'Start recording your consumption by clicking the orange (-) button next to your items.',
    noLearningHint: 'The more you use the app, the more accurate estimates become!',
  },
  // Profile
  profile: {
    editProfile: 'Edit Profile',
    householdSize: 'Number of people in household',
    reportDays: 'Report days',
    reportTime: 'Report time',
    allDays: 'All days',
    save: 'Save',
  },
  // Password
  password: {
    change: 'Change Password',
    current: 'Current password',
    new: 'New password',
    confirm: 'Confirm new password',
    submit: 'Change password',
  },
  feedback: {
    title: 'Feedback & Support',
    description: 'Report a bug, ask for help, or share your opinion without leaving the app.',
    communityTitle: 'Reviews and customer care',
    communityDescription: 'A simple place to tell us what works and what should improve.',
    communityText: 'Every message helps SmartInventory improve household stock management, smart shopping lists, and purchase tracking for real homes.',
    reviewPromptTitle: 'Also publish your review on Google Play',
    reviewPromptText: 'If the app helps you day to day, you can also leave a public review through the Play Store.',
    playStoreButton: 'Open Google Play',
    recentTitle: 'Your latest submissions',
    recentDescription: 'Quick history of the messages you sent to the team.',
    empty: 'No message sent yet.',
    types: {
      bug: 'Bug report',
      support: 'Customer support',
      review: 'User review',
    },
    form: {
      type: 'Request type',
      contact: 'Contact email',
      rating: 'User rating',
      message: 'Description',
      messagePlaceholder: 'Describe the bug, your support need, or your user feedback.',
      screenshot: 'Optional screenshot',
      screenshotHint: 'PNG, JPG, or WebP. Recommended size below 1.5 MB.',
      send: 'Send',
      sending: 'Sending...',
    },
    success: {
      sent: 'Your message has been sent.',
    },
    errors: {
      submit: 'Unable to send your message.',
      imageTooLarge: 'The screenshot is too large.',
    },
  },
  about: {
    badge: 'Why SmartInventory?',
    title: 'About SmartInventory',
    description: 'SmartInventory is designed for household stock management, smart shopping lists, purchase tracking, and more responsible consumption. It helps you manage your food budget and understand your real habits.',
    valueCardTitle: 'Product promise',
    valueCardText: 'Fewer impulse purchases, better visibility, and stronger budget control for the whole household.',
    openOnboarding: 'Replay onboarding',
    keywords: ['household stock management', 'smart shopping list', 'food budget', 'responsible consumption', 'purchase tracking'],
    cards: {
      smartShoppingTitle: 'Smarter shopping',
      smartShoppingDescription: 'Useful suggestions, not noisy ones.',
      smartShoppingText: 'SmartInventory highlights recent and frequent products so you can prepare shopping trips without starting from scratch.',
      budgetTitle: 'Clearer food budget',
      budgetDescription: 'A practical view of your spending.',
      budgetText: 'Track monthly expenses, compare your habits, and adjust your food budget with simple, useful guidance.',
      responsibleTitle: 'More responsible consumption',
      responsibleDescription: 'Buy what you need, when you need it.',
      responsibleText: 'By seeing household stock and purchase history together, you reduce waste and make better shopping decisions.',
    },
  },
  onboarding: {
    title: 'Discover SmartInventory',
    skip: 'Skip',
    previous: 'Previous',
    next: 'Next',
    finish: 'Start',
    step: 'Screen {number}',
    impulse: {
      headline: '🛒 Avoid impulse buying',
      body: 'Plan your shopping more intelligently and buy only what you really need thanks to suggestions and real stock visibility.',
    },
    history: {
      headline: '📊 Visualize your history',
      body: 'Track your shopping habits, understand your consumption rhythm, and see which products you buy most often.',
    },
    budget: {
      headline: '💰 Control your budget',
      body: 'Adjust your purchases to match your budget, personalize your spending limits, and manage expenses with more confidence.',
    },
  },
  // Purge
  purge: {
    title: 'Danger Zone',
    warning: 'This will delete ALL your data (items, movements, purchases). This action is irreversible!',
    button: 'Purge all my data',
    confirmTitle: 'WARNING',
    confirmMessage: 'Are you ABSOLUTELY sure you want to delete ALL your data?\n\nThis action is IRREVERSIBLE!\n\nAll your items, movements and history will be permanently deleted.',
    success: 'Data purged successfully',
    error: 'Error purging data',
  },
  // Receipt Scanner
  receipt: {
    title: 'Scan a receipt',
    uploading: 'Uploading...',
    analyzing: 'AI analyzing receipt...',
    analyzeStep1: 'Sending images to server...',
    analyzeStep2: 'AI is analyzing your receipt...',
    analyzeStep3: 'Extracting items...',
    analyzeComplete: 'Analysis complete!',
    addPhotos: 'Add photos',
    takePhoto: 'Take a photo',
    maxPhotos: 'Maximum 3 photos',
    analyze: 'Analyze receipt',
    detected: 'items detected',
    addAll: 'Add all items',
    store: 'Store',
    date: 'Date',
    total: 'Total',
  },
  // Barcode Scanner
  barcode: {
    title: 'Scan a barcode',
    scanning: 'Scanning...',
    productFound: 'Product found',
    productNotFound: 'Product not found',
    addToStock: 'Add to stock',
    enterManually: 'Manual entry',
  },
  // Auth
  auth: {
    login: 'Login',
    register: 'Register',
    username: 'Email or username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    userType: 'User type',
    particular: 'Individual',
    professional: 'Professional',
    householdSize: 'Number of people in household',
    loginButton: 'Sign in',
    registerButton: 'Sign up',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    newPassword: 'New password',
    resetButton: 'Reset',
    backToLogin: 'Back to login',
  },
  // Common
  common: {
    loading: 'Loading...',
    loadingFamily: 'Loading your family space...',
    error: 'Error',
    success: 'Success',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    search: 'Search',
    filter: 'Filter',
    noData: 'No data',
    refresh: 'Refresh',
  },
  // Days
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  // Categories
  categories: {
    food: 'Food',
    drink: 'Beverages',
    hygiene: 'Hygiene',
    household: 'Household',
    dairy: 'Dairy',
    bakery: 'Bakery',
    canned: 'Canned',
    other: 'Other',
  },
  // Units
  units: {
    kg: 'kg',
    g: 'g',
    L: 'L',
    ml: 'mL',
    pieces: 'pieces',
  },
  // History
  history: {
    title: 'Purchase History',
    weekly: 'Weekly',
    monthly: 'Monthly',
    noHistory: 'No purchase history',
    total: 'Total',
    purchases: 'purchases',
    spent: 'spent',
    week: 'Week',
  },
  // Language
  lang: {
    switchTo: 'Français',
    current: 'EN',
  },
  // Subscription
  subscription: {
    title: 'Subscription & Payment',
    trialActive: 'Free trial active',
    trialExpired: 'Free trial expired',
    active: 'Subscription active',
    expired: 'Subscription expired',
    cancelled: 'Subscription cancelled',
    daysLeft: 'days left',
    subscribe: 'Subscribe',
    cancel: 'Cancel subscription',
    price: '/month',
    paypal: 'PayPal',
    creditCard: 'Credit Card',
    cardLast4: 'Last 4 digits',
    paymentHistory: 'Payment History',
    noPayments: 'No payments',
    startTrial: 'Start free trial',
    trialInfo: '7-day free trial, then €2.99/month',
    payNow: 'Pay now',
    mockNotice: 'Demo mode - No real payment will be processed',
  },
  // Household
  household: {
    title: 'My Household',
    create: 'Create household',
    name: 'Household name',
    members: 'Members',
    invite: 'Invite',
    invitePlaceholder: 'Email or username',
    pending: 'Pending',
    owner: 'Owner',
    member: 'Member',
    leave: 'Leave household',
    delete: 'Delete household',
    noHousehold: 'You don\'t belong to any household',
    createInfo: 'Create a household to share your inventory with your family',
    invitations: 'Received invitations',
    accept: 'Accept',
    decline: 'Decline',
    noInvitations: 'No invitations',
    sharedStock: 'Shared stock',
    remove: 'Remove',
    invitedBy: 'Invited by',
  },
};

export default en;
